// ai创作相关接口调用
import { aiApi } from '@/request/index.js';
import BaseServer from '@/domain/common/base.server.js';
import useRoomBaseServer from '@/domain/room/roombase.server.js';
import usePlayerServer from '@/domain/player/player.server.js'
import axios from 'axios/dist/axios';

let fetchingPromise = null;
class AiServer extends BaseServer {
  static getInstance() {
    if (!this.instance) {
      this.instance = new AiServer();
    }
    return this.instance;
  }

  constructor() {
    super();

    this.state = {
      // 精彩时刻
      momentsList: null,

      // 概要总结
      summaryInfo: null,

      // 智能字幕开关
      subtitleSwitch: -1,

      // 智能字幕样式
      subtitleStyle: null,
    };

    return this;
  }

  // 聚合接口
  getAiVideoUnionInfo(record_id) {
    if (this.state.momentsList &&
      this.state.summaryInfo &&
      this.state.subtitleSwitch > -1 &&
      this.state.subtitleStyle
    ) {

      // 都有值就不重新获取
      return;
    }
    if (!record_id) {
      record_id = useRoomBaseServer().state.watchInitData.record.record_id
    }
    if (!record_id) {
      this.$emit('changeMomentsProperty', false);
      this.$emit('changeSummaryProperty', false);
      return;
    }
    // 正在请求中，防止重复请求
    if (fetchingPromise) {
      // 如果存在正在进行的请求，直接返回当前请求的Promise
      return fetchingPromise;
    }
    fetchingPromise = aiApi.getAiUnionInfo({ record_id }).then(res => {
      if (res && res.code === 200) {
        // 字幕开关
        this.state.subtitleSwitch = res.data.subtitles.ai_subtitle_switch;

        // 字幕样式
        this.state.subtitleStyle = res.data?.subtitle_style;

        // 精彩时刻
        if (res.data?.moments.file_url) {
          // 获取精彩时刻具体数据
          axios.get(res.data.moments.file_url).then((response) => {
            this.state.momentsList = response.data.highlight.map(item => {
              item.time = Math.floor(item.start_time / 1000);
              return item;
            });
            this.$emit('changeMomentsProperty', true);

            // 设置打点
            usePlayerServer().setMomentsList(this.state.momentsList);
          }).catch(err => {
            this.$emit('changeMomentsProperty', false);
          });
        } else {
          this.$emit('changeMomentsProperty', false);
        }

        // 概要总结
        if (res.data?.summary.file_url) {
          // 获取概要总结具体数据
          axios.get(res.data.summary.file_url).then((response) => {
            this.state.summaryInfo = response.data;
            this.$emit('changeSummaryProperty', true);
          }).catch(err => {
            this.$emit('changeSummaryProperty', false);
          });
        } else {
          this.$emit('changeSummaryProperty', false);
        }
      } else {
        this.$emit('changeMomentsProperty', false);
        this.$emit('changeSummaryProperty', false);
      }
      fetchingPromise = null; // 清除请求Promise
      return res;
    }).catch(err => {
      fetchingPromise = null; // 清除请求Promise
      this.$emit('changeMomentsProperty', false);
      this.$emit('changeSummaryProperty', false);
      return err;
    });

    return fetchingPromise;
  }
}

export default function useAiServer() {
  return AiServer.getInstance();
}
